import React from 'react';
import PropTypes from 'prop-types';
import { currencyType } from '../../shared/types';
import { GigServiceCardListings as GigServiceCardListingsComponent } from '../../components/GigServices';

export const GigServiceCardListings = ({ source, currency = {}, ...props }) => (
    <GigServiceCardListingsComponent source={source} currency={currency} {...props} />
);

GigServiceCardListings.LAYOUT = GigServiceCardListingsComponent.LAYOUT;

GigServiceCardListings.propTypes = {
    source: PropTypes.string,
    currency: currencyType,
    ...GigServiceCardListingsComponent.propTypes,
};
